import { render, staticRenderFns } from "./SillyTokenInfoPage.vue?vue&type=template&id=0f05cc00&scoped=true"
import script from "./SillyTokenInfoPage.vue?vue&type=script&lang=js"
export * from "./SillyTokenInfoPage.vue?vue&type=script&lang=js"
import style0 from "./SillyTokenInfoPage.vue?vue&type=style&index=0&id=0f05cc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05cc00",
  null
  
)

export default component.exports